export default "__VITE_ASSET__BXUhVxV8__"